import React, { useEffect, useState } from 'react'
import { Alert, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import apiService from 'Service'
import { LICENSE_PAYMENT } from 'Constants/Routes'

export default function LicenseExpiryBanner() {
    const { t } = useTranslation()
    const [status, setStatus] = useState(null)

    useEffect(() => {
        apiService.Licensing.status()
            .then(setStatus)
            .catch(() => setStatus(null))
    }, [])

    if (!status?.AlertMessage) return null

    const variant = status.AlertSeverity === 'Danger' ? 'danger'
        : status.AlertSeverity === 'Warning' ? 'warning' : 'info'

    return (
        <Alert variant={variant} className="mb-2">
            <Alert.Heading>{t('license_expiry_alert')}</Alert.Heading>
            <p className="mb-2">{status.AlertMessage}</p>
            {status.HasPendingPayment && (
                <p className="small mb-2">{t('license_payment_pending_validation')}</p>
            )}
            <Button as={Link} to={LICENSE_PAYMENT} variant="outline-dark" size="sm">
                {t('report_license_payment')}
            </Button>
        </Alert>
    )
}
